import { Box } from '@mui/material';
import { lighten } from '@mui/material/styles';
import looksLikeDate from 'components/@home/drawers/HrBotDrawer/XMLViewer/looksLikeDate';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

const TextElement = ({ text, theme, xpath, onClick }) => {
  const link = typeof onClick === 'function';
  const overflow = theme.overflowBreak ? { overflowWrap: 'break-word', whiteSpace: 'normal' } : {};
  const dateLike = looksLikeDate(text);
  const linkSx = [
    link && {
      borderRadius: '4px',
      p: '2px',
      cursor: 'pointer',
      backgroundColor: '#eaeaac',
      '&:hover, &:focus': {
        backgroundColor: lighten('#ffffbb', 0.02),
      },
    },
    !link && {
      p: '2px',
      '&:hover, &:focus': {
        backgroundColor: 'inherit',
      },
    },
  ];
  return dateLike ? (
    text.split(/[-/]/).map((part, index) => (
      <Fragment key={index}>
        {index > 0 && <span>-</span>}
        <Box
          component="span"
          sx={linkSx}
          onClick={() =>
            typeof onClick === 'function' &&
            onClick(`${xpath}/tokenize(text(), '[-/]' )[position() = ${index + 1}]`, text)
          }
        >
          {part}
        </Box>
      </Fragment>
    ))
  ) : (
    <Box
      component="span"
      onClick={() => typeof onClick === 'function' && onClick(`${xpath}/text()`, text)}
      sx={linkSx}
      style={{ color: theme.textColor, ...overflow }}
    >
      {text}
    </Box>
  );
};

TextElement.propTypes = {
  text: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  xpath: PropTypes.string.isRequired,
};

export default TextElement;
